<!-- 新手引导 -->
<template>
  <div class="noviceGuide" v-if="isNovice">
    <div class="noviceGuide-wrap"></div>
    <!-- 新建项目 -->
    <div class="noviceGuide-box1" v-if="index == 0">
      <span class="confirm-btn1" @click="closeNoviceGuide(1)"></span>
    </div>
    <!-- 选择文件 -->
    <div class="noviceGuide-box2" v-if="index == 1">
    </div>
    <div class="noviceGuide-box2-2" v-if="index == 1">
      <span class="confirm-btn2" @click="closeNoviceGuide(2)"></span>
    </div>
    <!-- 项目设置 -->
    <div class="noviceGuide-box3" v-if="index == 2">
      <span class="confirm-btn3" @click="closeNoviceGuide(3)"></span>
    </div>
    <!-- 项目列表 -->
    <div class="noviceGuide-box4" v-if="index == 3">
      <span class="confirm-btn4" @click="closeNoviceGuide(4)"></span>
    </div>
    <!-- 新手指南 -->
    <!-- <div class="noviceGuide-box5" v-if="index == 4">
            <span class="confirm-btn5" @click="closeNoviceGuide()"></span>
        </div> -->
    <!-- 下载译文 -->
    <div class="noviceGuide-box6" v-if="index == 4">
      <span class="confirm-btn6" @click="closeNoviceGuide(5)"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isNovice: {
      type: [Boolean, String],
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      // index: 0 //显示哪个新手引导
    };
  },
  mounted() {
    setTimeout(() => {
      switch (this.index) {
        case 1:
          let fileDom = document.getElementsByClassName("el-upload-dragger")[0];
          let dom = document.getElementsByClassName("noviceGuide-box2")[0];
          let dom2 = document.getElementsByClassName("noviceGuide-box2-2")[0];
          let t = dom.getBoundingClientRect();
          let r = fileDom.getBoundingClientRect()
          dom.style.left = r.left + r.width / 2 - t.width / 2 + "px"
          dom.style.top = r.top + r.height / 2 - t.height / 2 + "px"
          setTimeout(async () => {
            dom2.style.left = await r.left + r.width / 2 + "px"
            console.log(t.bottom, dom.offsetTop + dom.offsetHeight);
            dom2.style.top = await dom.offsetTop + dom.offsetHeight + 2 + "px"
          }, 100);
          console.log(fileDom.getBoundingClientRect(), "?????????????");

          break;
        case 2:
          function setCoordinate(params) {
            let fileSetDom = document.getElementsByClassName("themeGoBut")[0];
            let dom = document.getElementsByClassName("noviceGuide-box3")[0];
            let t = dom.getBoundingClientRect();
            let r = fileSetDom.getBoundingClientRect()
            console.log(r,"??????????????");
            dom.style.left = r.left - t.width + r.width + 36 + "px" // 36为图片button区域 类似padading白块
            dom.style.bottom = document.body.offsetHeight - r.top - r.height - 6 + "px"
            // debugger
            console.log(fileSetDom.getBoundingClientRect(), "?????????????");
          }
          setCoordinate()

          break;

        default:
          break;
      }
    }, 200);



  },
  components: {},
  methods: {
    // async getUserInfo() {
    //   const response = await this.catReq1Service("/api/v1/user/getUserInfo");
    //   if (response.resultCode === "1") {
    //     this.index = response.result.guideProgress
    //     console.log("guideProgress: ", response.result.guideProgress)
    //   }
    // },
    //修改新手引导进度
    async setGuideProgress() {
      const response = await this.catReq1Service("/api/v1/user/updateGuideProgress", { guideProgress: this.index + 1 });
      if (response.resultCode === "1") {

      }
    },
    closeNoviceGuide(index) {
      this.setGuideProgress()
      this.$emit('closeNoviceGuide', index);
    }
  }
}
</script>

<style lang='less' scoped>
@media screen and (min-width: 992px) and (max-width: 1500px) {
  .noviceGuide-box2 {
    // zoom: 0.9;
  }
}
.noviceGuide {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow: hidden;
  .noviceGuide-wrap {
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.7;
  }
  .noviceGuide-box1 {
    width: 583px;
    height: 262px;
    background-image: url("../assets/imgs/noviceGuide/xjxm.png");
    background-size: 100% 100%;
    position: absolute;
    top: 53px;
    left: 246px;
    .confirm-btn1 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 190px;
      left: 295px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
  .noviceGuide-box2-2 {
    width: 534px;
    height: 226px;
    background-image: url("../assets/imgs/noviceGuide/shangchuan_wenzi.png");
    background-size: 100% 100%;
    position: absolute;
    .confirm-btn2 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 150px;
      left: 250px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
  .noviceGuide-box2 {
    width: 685px;
    height: 183px;
    background-image: url("../assets/imgs/noviceGuide/shangchuan.png");
    background-size: 100% 100%;
    position: absolute;
    // top: 343px;
    // left: 721px;
  }
  .noviceGuide-box3 {
    width: 612px;
    height: 368px;
    background-image: url("../assets/imgs/noviceGuide/wcjf.png");
    background-size: 100% 100%;
    position: absolute;
    // top: 510px;
    // left: 1077px;
    .confirm-btn3 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 195px;
      left: 180px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
  .noviceGuide-box4 {
    width: 710px;
    height: 273px;
    background-image: url("../assets/imgs/noviceGuide/xmlb.png");
    background-size: 100% 100%;
    position: absolute;
    top: 180px;
    left: 335px;
    .confirm-btn4 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 205px;
      left: 417px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
  .noviceGuide-box5 {
    width: 818px;
    height: 356px;
    background-image: url("../assets/imgs/noviceGuide/yhzn.png");
    background-size: 100% 100%;
    position: absolute;
    top: 184px;
    left: 11px;
    .confirm-btn5 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 190px;
      left: 533px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
  .noviceGuide-box6 {
    width: 587px;
    height: 262px;
    background-image: url("../assets/imgs/noviceGuide/wjbj.png");
    background-size: 100% 100%;
    position: absolute;
    top: 46px;
    right: 107px;
    .confirm-btn6 {
      width: 105px;
      height: 42px;
      background-image: url("../assets/imgs/noviceGuide/got_it_normal.png");
      background-size: 100% 100%;
      position: absolute;
      top: 194px;
      left: 180px;
      cursor: pointer;
    }
    :hover {
      background-image: url("../assets/imgs/noviceGuide/got_it_press.png");
    }
  }
}
</style>